import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Activity icon. Exported from Figma (Bombiix 2026). */
const ActivityIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path d="M16.6663 10H13.9997L11.9997 16L7.99967 4L5.99967 10H3.33301" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ActivityIcon;
